import { shape, string } from "prop-types";

import TourismLocation from "web/Pages/Product/Shared/Tourism/TourismLocation";
import TourismObjectInfo from "web/Pages/Product/Shared/Tourism/TourismObjectInfo";

import classes from "./objectInformation.scss";

const CheckoutTourismDomesticObjectInformation = ({ product, className }) => {
  return product ? (
    <div className={className || classes.root}>
      <TourismObjectInfo className={classes.item} product={product} />
      {product && (
        <TourismLocation className={classes.item} product={product} />
      )}
    </div>
  ) : null;
};

CheckoutTourismDomesticObjectInformation.defaultProps = {
  className: "",
};

CheckoutTourismDomesticObjectInformation.propTypes = {
  className: string,
  product: shape({}).isRequired,
};

export default CheckoutTourismDomesticObjectInformation;
